/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import Utilities from '../../global/Utilities';
import { COMMON, ADD_KRISHAK_SCREEN } from '../../global/Constants';

class AddImages extends Component {

    constructor(props) {
        super(props)

        this.isEdit = false;
        this.state = {
            images: [],
            addImageVisible: true,
            selectedFiles: [],
            isUpdate: false,
        }
    }

    componentDidMount() {
        let imagePaths = this.props.imagePaths;
        if (imagePaths) {
            //Utilities.LogPrint("imagePaths123", imagePaths);

            let imagePro = imagePaths.map(({ image_url: path, krishak_image_id: id, ...rest }) => ({ path, id, ...rest }));
            this.setState({
                images: imagePro
            })
        }
    }

    async componentDidUpdate(prevState, prevProps) {
        if (!this.isEdit) {
            if (prevProps?.imagePaths !== this.props?.imagePaths) {
                if (!this.state.isUpdate) {
                    const { imagePaths } = this.props;
                    //Utilities.LogPrint("$$imagePaths0", imagePaths);
                    if (imagePaths != null && imagePaths?.length > 0) {

                        this.setState({ images: imagePaths.map(({ image_url: path, krishak_image_id: id, ...rest }) => ({ path, id, ...rest })), isUpdate: true, addImageVisible: (imagePaths.length < 3) });
                        // this.setState({ images: imagePro, isUpdate: true, addImageVisible: (imagePaths.length < 3) });
                    }
                }
            }
        }
    }

    // On file select (from the pop up)
    onFileChange = event => {
        const newArray = this.state.images.slice(); // Create a copy
        const files = this.state.selectedFiles.slice();
        Utilities.LogPrint("Selected Image: ---- >", event.target.files[0]);
        if (newArray.length < 3) {
            if (event.target.files && event.target.files[0]) {
                let reader = new FileReader();
                reader.onload = (e) => {
                    this.isEdit = true;

                    let file = event.target.files[0];

                    const timestamp = new Date().getTime();
                    var randNumber = Math.floor(1000 + Math.random() * 9000);
                    var randSixDigitNumber = Math.floor(100000 + Math.random() * 900000);
                    var ext = file.name.split('.').pop();

                    var newFileName = randNumber + "_" + timestamp + "_" + randSixDigitNumber + "." + ext;
                    file = new File([file], newFileName);
                    let fileName = Math.random().toString(36).substring(7);
                    files.push({ file: file, name: newFileName });
                    this.fileToByteArray(file).then(result => {

                        const imageBase64 = Utilities.arrayBufferToBase64(result);
                        const imageUrl = `data:image/jpg;base64,${imageBase64}`;
                        // var blob = new Blob( [ result ], { type: "image/jpeg" } );
                        // var urlCreator = window.URL || window.webkitURL;
                        // var imageUrl = urlCreator.createObjectURL( blob );

                        newArray.push({ path: imageUrl, image_name: fileName, krishak_image_id: 0 });
                        this.setState({
                            images: newArray,
                            addImageVisible: (newArray.length < 3),
                            selectedFiles: files
                        }, () => {
                            this.props.handleAddImages(event, newArray, this.state.selectedFiles);
                        });
                    });

                    event.target.value = null;
                };
                reader.readAsDataURL(event.target.files[0]);


                //Utilities.LogPrint("Selected Image: ---- >", event.target.files[0]);
            }
        } else {
            alert("You can add maximum 3 Images");
        }


    };

    fileToByteArray(file) {
        return new Promise((resolve, reject) => {
            try {
                let reader = new FileReader();
                let fileByteArray = [];
                reader.readAsArrayBuffer(file);
                reader.onloadend = (evt) => {
                    if (evt.target.readyState === FileReader.DONE) {
                        //  fileByteArray = evt.target.result
                        const array = new Uint8Array(evt.target.result);

                        for (var i = 0; i < array.length; i++) {
                            fileByteArray.push(array[i]);
                        }

                    }
                    resolve(fileByteArray);

                }
            }
            catch (e) {
                alert("Choose a File");
                reject("Choose a File");
            }
        })
    }

    async getByteArray(myFile) {
        //Get file from your input element
        //Wait for the file to be converted to a byteArray
        let byteArray = await this.fileToByteArray(myFile);
        //Do something with the byteArray
        return byteArray
    }

    deleteImage = (e, item) => {
        this.props.deleteActivityImageApi(item);
        var array = [...this.state.images]; // make a separate copy of the array
        var index = array.indexOf(item);
        if (index !== -1) {
            array.splice(index, 1);
            this.setState({ images: array, addImageVisible: (array.length < 3) });
            // this.props.onAddNumberImages(array);
            this.props.handleAddImages(e, array, this.state.selectedFiles);
        }
    }

    handleGalleryCLick = () => {
        document.getElementById('file').click();
    }

    render() {
        const { images, addImageVisible } = this.state;
        const { fromFeedBack } = this.props;

        const imageListItem = images.map((image, i) => {
            return (
                <div className={fromFeedBack ? "col-4 col-lg-3 image-info img-close-btn" : "col-lg-2 col-4 image-info img-close-btn"} key={i}>
                    <img src={image.path} alt="" />
                    <a onClick={(e) => this.deleteImage(e, image)}><i className="customic ic-close"></i></a>
                </div>
            )
        });

        return (
            <div className="form-group">
                <label className={fromFeedBack ? "font-weight-medium" : "font-weight-medium mt-2"}>{COMMON.ADD_IMAGES} <span className="font-weight-normal">{fromFeedBack ? ADD_KRISHAK_SCREEN.IF_ANY : COMMON.MAX_3}</span></label>
                <div className="row row7-5">
                    {imageListItem}
                    <div className={addImageVisible ? fromFeedBack ? "col-4 col-lg-3" : "col-lg-2 col-4" : "d-none"}>
                        <div onClick={this.handleGalleryCLick} className="upload-img-box" >
                            <i className="customic ic-add"></i>
                            <input className="d-none" accept="image/*" id="file" type="file" onChange={this.onFileChange} />
                            <span className="uploaded-img d-none"></span>
                        </div>
                    </div>
                </div>
            </div>



        )
    }
}

export default AddImages
